import { render, staticRenderFns } from "./ModalESObjeto.vue?vue&type=template&id=00013eda&"
import script from "./ModalESObjeto.vue?vue&type=script&lang=js&"
export * from "./ModalESObjeto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports